import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ELIGIBLE_FOR_CAB} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {EligibleForCabContent} from './EligibleForCabContent';
import reportPayload from './reportPayload';

export const EligibleForCabReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Eligible for Client Acquisition Bonus')}
      description={tt(
        'description',
        'Help start these new Coaches right by helping them earn their CAB w/ 1000 FQV from 5 new Clients in their first 30 days.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={EligibleForCabContent}
    />
  );
};

export default withHOC(
  withTranslation('report.eligibleForCabReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ELIGIBLE_FOR_CAB,
    popoverContentProps: {},
  }),
)(EligibleForCabReport);
